module.exports = __webpack_public_path__ + "img/intro-04.9392b3ea.png";